export default {
    assigning: {
        visibleCommunities: '{visible} of {total} is visible to you | {visible} of {total} are visible to you',
    },
};
